import React from 'react';
import './PageMessageBanner.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';


interface PageMessageBannerProps {
    setShowMessageBanner: React.Dispatch<React.SetStateAction<boolean>>
}

function PageMessageBanner({ setShowMessageBanner }: PageMessageBannerProps) {

    return (
        <div id='message-banner'>
            <div className='banner-text'>
                <h3>Get a free copy of my Gratitude Journal &#091;<a href='https://trisha-somers-coaching.kit.com/41714b515c' target='new'>Click here</a>&#093;</h3>
            </div>
            <div className="banner-exit" >
                <FontAwesomeIcon icon={faXmark} id='exit-button' className='fa-xl' onClick={() => { setShowMessageBanner(false) }}/>
            </div>
        </div>
    );
}

export default PageMessageBanner